import { render } from "./IframeView.vue?vue&type=template&id=964591fa&scoped=true"
import script from "./IframeView.vue?vue&type=script&lang=js"
export * from "./IframeView.vue?vue&type=script&lang=js"

import "./IframeView.vue?vue&type=style&index=0&id=964591fa&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-964591fa"]])

export default __exports__